import React, { Fragment, useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { IProjectItem, IMembersSel } from '@src/entity/company/project';
import { Icon, Tabs, Menu, SearchBar, Drawer, List, Button, Flex, ListView, PullToRefresh } from 'antd-mobile';
import { RouteComponentProps } from 'react-router';
import 'react-circular-progressbar/dist/styles.css';
import SelectUnder from '../../../components/Common/SelectUnder';
import { throttle } from '@clouderwork/ywk/build/main/utils';
import { Header } from '@ywk/mobile-components';
import PlusBtn from '@src/components/Common/PlusBtn';
import company from '@src/store/company';
import TabContent from './TabContent';
import { useInputFocus } from '@src/utils/hooks';
import './style.less';

export let initData = [
  {
    value: '1',
    label: '负责和参与的项目'
  },
  {
    value: '2',
    label: '关注的项目'
  },
  {
    value: '3',
    label: '创建的项目'
  },
  {
    value: '4',
    label: '下属的项目',
    isLeaf: true
  }
];

const tabData = [
  // { title: "进行中", sub: "having" },
  // { title: "已完成", sub: "finish" },
  { title: '全部', sub: 'all' }
];

let autoFocusInst: any;

const ProjectList = observer((props: RouteComponentProps) => {
  const {
    projects,
    selects,
    getProjects,
    menuIndex,
    ajaxStatus,
    updateCurList,
    getUsers,
    projectCount,
    members
  } = company.project;
  const { user, activeCompany } = company.user;
  const [menuShow, setMenuShow] = useState(false);
  // 设置搜索栏是否显示
  const [inSearch, setInSearch] = useState(false);
  // 抽屉是否显示
  const [inFilter, setInFilter] = useState(false);
  // 负责人筛选
  const [chargeFilter, setChargeFilter] = useState(false);

  // 创建人筛选
  const [creatorFilter, setCreatorFilter] = useState(false);
  // // 设置打开选择下属页时的入口类型 1 负责人 2 创建人
  // const [fullType, setFullType] = useState(0);

  const [_projects, setProjects] = useState<IProjectItem[]>([]);
  const [isloading, setIsloading] = useState<boolean>(false);
  const [keyword, setKeyword] = useState('');
  useInputFocus(inSearch);
  if (company.user.managed === false) {
    initData = [
      {
        value: '1',
        label: '负责和参与的项目'
      },
      {
        value: '2',
        label: '关注的项目'
      },
      {
        value: '3',
        label: '创建的项目'
      }
    ];
  }
  useEffect(() => {
    if (keyword) {
      setProjects(updateCurList(keyword));
    } else {
      console.log('setProjects', projects);
      setProjects(projects);
    }
  }, [keyword, projects]);

  useEffect(() => {
    if (inSearch) {
      if (autoFocusInst) {
        autoFocusInst.focus();
      }
    }
  }, [inSearch]);

  const searchHandler = evt => {
    setInSearch(true);
  };

  let rightContent = [<span className="icon-search" key="0" onClick={searchHandler}></span>];
  if (selects.mode === 4) {
    rightContent.push(
      <img
        onClick={() => {
          setInFilter(!inFilter);
        }}
        className="filter-btn"
        key="1"
        src={require('@src/assets/images/company/icon-filter.png')}
      />
    );
  }

  useEffect(() => {
    setIsloading(true);
    getProjects().then(() => {
      setIsloading(false);
      // console.log(company.project.projects.length, company.project.ajaxStatus);
    });
    getUsers(company.user.user.company_uuid);

    // 监听上一个页面关闭操作
    window.YwkHybrid.JSBridge.registerHandler('page.nextPageClose', () => {
      // Toast.fail('page.nextPageClose');
      setIsloading(true);

      getProjects().then(() => {
        setIsloading(false);
      });
    });
  }, [getProjects, getUsers]);

  const toggleMenu = () => {
    setMenuShow(!menuShow);
  };

  return (
    <div className="ProjectList">
      {!inSearch ? (
        <Header rightContent={rightContent} style={{ zIndex: !inFilter ? 100 : 'inherit' }}>
          <Fragment>
            <div
              onClick={() => {
                toggleMenu();
              }}
              className="menu-toggle-btn"
            >
              <span className="menu-toggle-inner">{initData[menuIndex].label}</span>
              <span>
                <Icon type="down" size="xxs" />
              </span>
            </div>
            <Menu
              level={1}
              value={[selects.mode.toString()]}
              data={initData}
              className="single-foo-menu"
              height={menuShow ? 40 * initData.length + 16 : 0}
              onChange={(item: any) => {
                selects.mode = +item[0];
                if (+item[0] !== 4) {
                  selects.manager = '';
                  selects.creator = '';
                }
                setIsloading(true);
                getProjects().then(() => setIsloading(false));
                toggleMenu();
              }}
            />
            {/* ) : null} */}
            {menuShow ? <div className="menu-mask" onClick={toggleMenu} /> : null}
          </Fragment>
        </Header>
      ) : (
        <SearchBar
          style={{ zIndex: !inFilter ? 100 : 'inherit', position: 'relative' }}
          className="top-search navbar"
          placeholder="搜索"
          cancelText="取消"
          onChange={val => {
            throttle(setKeyword(val));
          }}
          ref={ref => (autoFocusInst = ref)}
          showCancelButton={true}
          onCancel={() => {
            setKeyword('');
            setInSearch(false);
          }}
        />
      )}
      <article>
        <div className="project-wrapper-list">
          <TabContent sub="all" projects={_projects} isloading={isloading} hasMore={_projects.length > 6} />
        </div>
      </article>
      {
        <Drawer
          open={inFilter}
          sidebar={
            <div className="filter-menu">
              <h5>筛选条件</h5>
              <List>
                <List.Item
                  arrow="horizontal"
                  extra={selects.manager && <span className="selected">已选1个</span>}
                  onClick={() => {
                    // setFullType(1);
                    setChargeFilter(!chargeFilter);
                  }}
                >
                  负责人
                </List.Item>
                <List.Item
                  arrow="horizontal"
                  extra={selects.creator && <span className="selected">已选1个</span>}
                  onClick={() => {
                    // setFullType(2);
                    setCreatorFilter(!creatorFilter);
                  }}
                >
                  创建人
                </List.Item>
              </List>
              <Flex className="sidebar-footer">
                <Flex.Item>
                  <Button
                    className="cancel-btn"
                    onClick={() => {
                      selects.creator = '';
                      selects.manager = '';
                    }}
                  >
                    清除条件
                  </Button>
                </Flex.Item>
                <Flex.Item>
                  <Button
                    className="confirm-btn"
                    onClick={() => {
                      setIsloading(true);
                      getProjects().then(() => setIsloading(false));
                      setInFilter(!inFilter);
                    }}
                  >
                    确定
                  </Button>
                </Flex.Item>
              </Flex>
            </div>
          }
          onOpenChange={() => setInFilter(!inFilter)}
          position="right"
          className="drawer-sidebar"
        >
          {' '}
        </Drawer>
      }
      {
        <Drawer
          open={chargeFilter}
          position="right"
          sidebar={
            <SelectUnder
              cancelCallback={() => {
                setChargeFilter(!chargeFilter);
              }}
              selected={(member: IMembersSel) => {
                if (!Array.isArray(member)) {
                  selects.manager = member.uuid;
                }
                setChargeFilter(!chargeFilter);
              }}
              singleUser={members.find(member => member.uuid === selects.manager)}
              dataSource={members}
              loading={ajaxStatus === 'pending'}
              companyName={!activeCompany ? '' : activeCompany.entityName}
            />
          }
          className="full-sidebar"
        >
          {' '}
        </Drawer>
      }
      {
        <Drawer
          open={creatorFilter}
          position="right"
          sidebar={
            <SelectUnder
              cancelCallback={() => {
                setCreatorFilter(!creatorFilter);
              }}
              selected={member => {
                if (!Array.isArray(member)) {
                  selects.creator = member.uuid;
                }
                setCreatorFilter(!creatorFilter);
              }}
              singleUser={members.find(member => member.uuid === selects.creator)}
              dataSource={members}
              loading={ajaxStatus === 'pending'}
              companyName={!activeCompany ? '' : activeCompany.entityName}
            />
          }
          className="full-sidebar"
        >
          {' '}
        </Drawer>
      }
      {!inFilter && <PlusBtn url={`${location.origin}/company/project/create/`} />}
    </div>
  );
});

export default ProjectList;
